import React from 'react'
import { Link } from 'react-router-dom'
import SeoHead from '../components/SeoHead'

export default function NotFoundPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center py-20 px-4 sm:px-6 bg-[#f4f4f5]">
      <SeoHead
        title="Siden blev ikke fundet (404) - Emmerske Efterskole"
        description="Den side, du leder efter, findes desværre ikke på Emmerske Efterskoles hjemmeside."
      />

      <div className="max-w-xl mx-auto text-center bg-white p-8 sm:p-12 rounded-3xl border border-stone-200/80 shadow-lg space-y-6">
        <div className="w-20 h-20 rounded-full bg-[#eff8f4] text-[#007a53] flex items-center justify-center mx-auto text-3xl font-extrabold">
          404
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl sm:text-3xl font-extrabold text-[#122020]">
            Siden blev ikke fundet
          </h1>
          <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
            Vi kunne desværre ikke finde den side, du ledte efter. 
            Måske er siden flyttet i forbindelse med vores nye hjemmeside, eller linket er indtastet forkert.
          </p>
        </div>

        <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/" className="btn-primary w-full sm:w-auto">
            <i className="fa-solid fa-house" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>
          <Link to="/kontakt" className="btn-secondary w-full sm:w-auto">
            <i className="fa-solid fa-envelope" aria-hidden="true" />
            <span>Kontakt os</span>
          </Link>
        </div>

        <div className="pt-6 border-t border-stone-100 text-left">
          <p className="text-xs font-semibold text-stone-500 uppercase tracking-wider mb-3">
            Måske ledte du efter:
          </p>
          <div className="grid grid-cols-2 gap-2 text-xs">
            <Link to="/undervisning" className="text-[#007a53] hover:underline p-1.5 rounded hover:bg-stone-50">
              → Undervisning & LST
            </Link>
            <Link to="/undervisning/valgfag" className="text-[#007a53] hover:underline p-1.5 rounded hover:bg-stone-50">
              → Praktiske Valgfag
            </Link>
            <Link to="/rundvisning" className="text-[#007a53] hover:underline p-1.5 rounded hover:bg-stone-50">
              → Book rundvisning
            </Link>
            <Link to="/om-os" className="text-[#007a53] hover:underline p-1.5 rounded hover:bg-stone-50">
              → Om skolen & hverdagen
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
